exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chat-input-section .alert-success[data-v-965bdc6c]{\n\tmin-width: 330px;\n}\n", ""]);

// exports
